import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import SocialGroupsList from './SocialGroupsList';

export default class GroupsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
  }

  view() {
    return (
      <div className="GroupsPage">
        <div className="GroupsPage-container">
          <SocialGroupsList />
        </div>
      </div>
    );
  }
}

